import { useEffect, useState } from "react";
import noticeError from "src/app/utilities/noticeError";

import isOutOfHours from "src/app/utilities/isOutOfHours";

const useOutOfHours = ({ storeCode, countryCode }) => {
  const [outOfHours, setOutOfHours] = useState(false);

  useEffect(() => {
    const getOutOfHours = async () => {
      try {
        const outOfHours = await isOutOfHours({ storeCode, countryCode });
        setOutOfHours(outOfHours);
      } catch (error) {
        noticeError(error);
      }
    };

    getOutOfHours();
  }, [countryCode, storeCode]);

  return {
    outOfHours,
  };
};

export default useOutOfHours;
